<template>
  <div class="selection-options">
    <div class="search-menu-label">
      SELECTION
    </div>
  <div class="selection-buttons">
    <div class="select box" title="Toggle Multi Select" @mouseup="toggleMultiSelectionMode">
      {{ (RMTStore.inMultiSelectionMode) ? 'DONE' : 'SELECT' }}
    </div>
    <div class="all box" title="Select All Displayed Items" @mouseup="confirmSelectAll">
      ALL
    </div>
    <div class="clear box" :class="selectionCount === 0 ? 'disable' : 'enable'" title="Clear All Selected Items"
         @click="confirmClearAll">
      CLEAR
    </div>
  </div>
  </div>
</template>

<script>
import {useRMTStore} from '@/store/RMTStore';
import {useModalStore} from '@/store/ModalStore';
import {useResourceStore} from '@/store/ResourceStore';

export default {
  name: 'SelectionOptions',
  setup () {
    const RMTStore = useRMTStore();
    const modalStore = useModalStore();
    const resourceStore = useResourceStore();
    return {
      RMTStore, modalStore, resourceStore
    };
  },

  computed: {
    selectionCount () {
      const RMTStore = useRMTStore();
      return RMTStore.inUploadMode ? RMTStore.selectedUploads.length : RMTStore.selectedResources.length;
    },
  },
  methods: {
    toggleMultiSelectionMode () {
      this.RMTStore.toggleMultiSelectionMode();
    },
    confirmSelectAll () {
      if (this.RMTStore.inUploadMode) {
        this.RMTStore.selectAllUploads();
        this.RMTStore.uploadedFileData = this.RMTStore.updateAssociations(this.RMTStore.selectedUploads);
      } else {
        let resourceCount = this.resourceStore.resources.length;
        if (resourceCount < 50) {
          this.selectAll();
          return;
        }
        this.modalStore.setModalObj({
          promptLabel: 'Select All',
          promptDescription: 'Are you sure you want to add ' + resourceCount + ' items to your selection?',
          buttonALabel: 'CONFIRM',
          buttonAFunc: this.selectAll,
          buttonBLabel: 'Cancel',
          buttonBFunc: this.cancelPrompt
        });
        this.modalStore.showModal('prompt');
      }
    },
    selectAll () {
      this.RMTStore.selectAllResources();
      this.RMTStore.setPanelIsHidden(false);
      this.modalStore.hideModal();
      this.RMTStore.setUploadedFiles(this.resourceStore.resources, true);
    },
    confirmClearAll () {
      this.modalStore.setModalObj({
        promptLabel: 'Clear All',
        promptDescription: 'Are you sure you want to clear all item selections?',
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.clearAll,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelPrompt
      });
      this.modalStore.showModal('prompt');
    },
    clearAll () {
      this.modalStore.hideModal();

      if (this.RMTStore.inCreateCollectionMode) {
        this.RMTStore.clearSelectedResources();
      } else {
        this.RMTStore.clearAll();
      }

    },
    cancelPrompt () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>

.select {
  margin-right: 5px;
  min-width: 63px;
}

.all {
  margin-right: 5px;
}

.box {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-self: center;
  text-align: center;
  background-color: lightgrey;
  padding: 3px 11px;
  font-size: .72em;
  /*  letter-spacing: .05em;*/
  font-weight: 600;
  margin-top:4px;
}

.selection-options {
  display: flex;
  flex-direction: column;
}

.selection-buttons {
  display: flex;
}

</style>